import { render, staticRenderFns } from "./zjl.vue?vue&type=template&id=583c3094"
import script from "./zjl.vue?vue&type=script&lang=js"
export * from "./zjl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports